import React from 'react';

import Spinner from 'react-spinner-material';
import {
  GraphBarCustomLateralONE,
  NewGraphBar,
} from '../../../utils/newGraphsBar';
import styles from './styles.module.scss';

export default function Usuarios({
  totalUser,
  novosUser,
  PfUser,
  PjUser,
  PjMeiUser,
  PjMeUser,
  PjEppUser,
  PjOutrosUser,
  AtivosAgoraUser,
  AtivosAgoraPfUser,
  AtivosAgoraPjUser,
  ufUser,

  isLoadingTotalUser,
  isLoadingNovosUser,
  isLoadingPfUser,
  isLoadingPjUser,
  isLoadingPjMeiUser,
  isLoadingPjMeUser,
  isLoadingPjEppUser,
  isLoadingPjOutrosUser,
  isLoadingAtivosAgoraUser,
  isLoadingAtivosAgoraPfUser,
  isLoadingAtivosAgoraPjUser,
  isLoadingUfUser,
}) {
  const renderTotal = () => (
    <div
      className={isLoadingTotalUser ? styles.render_spinner_container : null}
    >
      {isLoadingTotalUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingTotalUser && (
        <NewGraphBar
          dataGraphs={totalUser?.atendimentos}
          total={
            totalUser?.total === 0 ||
            totalUser?.total === 'NaN' ||
            totalUser?.total === undefined
              ? '0'
              : totalUser?.total
          }
          label="total"
          position="mes*total"
          subLabel="usuários"
          labelModal="total"
          date={totalUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );
  const renderNovos = () => (
    <div
      className={isLoadingNovosUser ? styles.render_spinner_container : null}
    >
      {isLoadingNovosUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingNovosUser && (
        <NewGraphBar
          dataGraphs={novosUser?.atendimentos}
          total={
            novosUser?.total === 0 ||
            novosUser?.total === 'NaN' ||
            novosUser?.total === undefined
              ? '0'
              : novosUser?.total
          }
          label="novos"
          position="mes*total"
          subLabel="usuários"
          labelModal="novos"
          date={novosUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );
  const renderPf = () => (
    <div className={isLoadingPfUser ? styles.render_spinner_container : null}>
      {isLoadingPfUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingPfUser && (
        <NewGraphBar
          dataGraphs={PfUser?.atendimentos}
          total={
            PfUser?.total === 0 ||
            PfUser?.total === 'NaN' ||
            PfUser?.total === undefined
              ? '0'
              : PfUser?.total
          }
          label="pessoa física"
          position="mes*total"
          subLabel="usuários"
          subLabelOtherColor="PF"
          labelModal="pessoa física"
          date={PfUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  const renderPj = () => (
    <div className={isLoadingPjUser ? styles.render_spinner_container : null}>
      {isLoadingPjUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingPjUser && (
        <NewGraphBar
          dataGraphs={PjUser?.atendimentos}
          total={
            PjUser?.total === 0 ||
            PjUser?.total === 'NaN' ||
            PjUser?.total === undefined
              ? '0'
              : PjUser?.total
          }
          label="pessoa jurídica"
          position="mes*total"
          subLabel="usuários"
          subLabelOtherColor="PJ"
          labelModal="pessoa jurídica"
          date={PjUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  const renderPjMei = () => (
    <div
      className={isLoadingPjMeiUser ? styles.render_spinner_container : null}
    >
      {isLoadingPjMeiUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingPjMeiUser && (
        <NewGraphBar
          dataGraphs={PjMeiUser?.atendimentos}
          total={
            PjMeiUser?.total === 0 ||
            PjMeiUser?.total === 'NaN' ||
            PjMeiUser?.total === undefined
              ? '0'
              : PjMeiUser?.total
          }
          label="MEI"
          labelOtherColor="PJ"
          position="mes*total"
          subLabel="usuários"
          labelModal="por porte"
          subLabelModal="MEI"
          date={PjMeiUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  const renderPjMe = () => (
    <div className={isLoadingPjMeUser ? styles.render_spinner_container : null}>
      {isLoadingPjMeUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingPjMeUser && (
        <NewGraphBar
          dataGraphs={PjMeUser?.atendimentos}
          total={
            PjMeUser?.total === 0 ||
            PjMeUser?.total === 'NaN' ||
            PjMeUser?.total === undefined
              ? '0'
              : PjMeUser?.total
          }
          label="ME"
          labelOtherColor="PJ"
          position="mes*total"
          subLabel="usuários"
          labelModal="por porte"
          subLabelModal="ME"
          date={PjMeUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  const renderPjEpp = () => (
    <div
      className={isLoadingPjEppUser ? styles.render_spinner_container : null}
    >
      {isLoadingPjEppUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingPjEppUser && (
        <NewGraphBar
          dataGraphs={PjEppUser?.atendimentos}
          total={
            PjEppUser?.total === 0 ||
            PjEppUser?.total === 'NaN' ||
            PjEppUser?.total === undefined
              ? '0'
              : PjEppUser?.total
          }
          label="EPP"
          labelOtherColor="PJ"
          position="mes*total"
          subLabel="usuários"
          labelModal="por porte"
          subLabelModal="EPP"
          date={PjEppUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  const renderPjOutros = () => (
    <div
      className={isLoadingPjOutrosUser ? styles.render_spinner_container : null}
    >
      {isLoadingPjOutrosUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingPjOutrosUser && (
        <NewGraphBar
          dataGraphs={PjOutrosUser?.atendimentos}
          total={
            PjOutrosUser?.total === 0 ||
            PjOutrosUser?.total === 'NaN' ||
            PjOutrosUser?.total === undefined
              ? '0'
              : PjOutrosUser?.total
          }
          label="OUTROS"
          labelOtherColor="PJ"
          position="mes*total"
          subLabel="usuários"
          labelModal="por porte"
          subLabelModal="OUTROS"
          date={PjOutrosUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  const renderAtivosAgora = () => (
    <div
      className={
        isLoadingAtivosAgoraUser ? styles.render_spinner_container : null
      }
    >
      {isLoadingAtivosAgoraUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingAtivosAgoraUser && (
        <NewGraphBar
          dataGraphs={AtivosAgoraUser?.atendimentos}
          total={
            AtivosAgoraUser?.total === 0 ||
            AtivosAgoraUser?.total === 'NaN' ||
            AtivosAgoraUser?.total === undefined
              ? '0'
              : AtivosAgoraUser?.total
          }
          label="ativos agora"
          position="mes*total"
          subLabel="usuários"
          labelModal="ativos agora"
          date={AtivosAgoraUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  const renderAtivosAgoraPf = () => (
    <div
      className={
        isLoadingAtivosAgoraPfUser ? styles.render_spinner_container : null
      }
    >
      {isLoadingAtivosAgoraPfUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingAtivosAgoraPfUser && (
        <NewGraphBar
          dataGraphs={AtivosAgoraPfUser?.atendimentos}
          total={
            AtivosAgoraPfUser?.total === 0 ||
            AtivosAgoraPfUser?.total === 'NaN' ||
            AtivosAgoraPfUser?.total === undefined
              ? '0'
              : AtivosAgoraPfUser?.total
          }
          label="ativos agora"
          labelOtherColor="PF"
          position="mes*total"
          subLabel="usuários"
          labelModal="ativos agora"
          subLabelModal="PF"
          date={AtivosAgoraPfUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  const renderAtivosAgoraPj = () => (
    <div
      className={
        isLoadingAtivosAgoraPjUser ? styles.render_spinner_container : null
      }
    >
      {isLoadingAtivosAgoraPjUser && (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      )}
      {!isLoadingAtivosAgoraPjUser && (
        <NewGraphBar
          dataGraphs={AtivosAgoraPjUser?.atendimentos}
          total={
            AtivosAgoraPjUser?.total === 0 ||
            AtivosAgoraPjUser?.total === 'NaN' ||
            AtivosAgoraPjUser?.total === undefined
              ? '0'
              : AtivosAgoraPjUser?.total
          }
          label="ativos agora"
          labelOtherColor="PJ"
          position="mes*total"
          subLabel="usuários"
          labelModal="ativos agora"
          subLabelModal="PJ"
          date={AtivosAgoraPjUser?.data}
          otherTitle="Usuários"
        />
      )}
    </div>
  );

  // const memoizedValue = useMemo(() => ufUser?.uf?.reverse(), [ufUser]);
  const renderUf = () => (
    <div
      className={isLoadingUfUser ? styles.render_spinner_container_ufs : null}
    >
      {isLoadingUfUser ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <GraphBarCustomLateralONE
          dataGraphsUf={ufUser?.uf}
          // dataGraphsUf={memoizedValue}
          position="uf*total"
          label="Usuários:"
          tab1="por UF"
          titleUF={ufUser?.descUF}
        />
      )}
    </div>
  );

  return (
    <div className={styles.central_container}>
      <div className={styles.render_big_container}>
        <div className={styles.render_big_container2}>
          <div className={styles.render_graph_container1}>
            {renderTotal()}
            {renderNovos()}
            {renderPf()}
            {renderPj()}
          </div>
          <div className={styles.render_graph_container1}>
            {renderPjMei()}
            {renderPjMe()}
            {renderPjEpp()}
            {renderPjOutros()}
          </div>
        </div>
        <div className={styles.graphBar_lateral_container}>{renderUf()}</div>
      </div>
      <div className={styles.render_big_container3}>
        <div className={styles.render_graph_container2}>
          {renderAtivosAgora()}
          {renderAtivosAgoraPf()}
          {renderAtivosAgoraPj()}
        </div>
      </div>
    </div>
  );
}
